const isDev = process.env.NODE_ENV !== "production";

// export const BASE_URL = "https://mt-emea-oasis.apexdigital.online";
export const BASE_URL = (isDev ? "http://localhost:8000" : process.env.REACT_APP_BASE_URL)!;
export const API_PREFIX = "/api/v1";
